<template>
  <span :class="['checkpoint-inspection-badge', `checkpoint-inspection-badge--${displayState}`]">
    {{ displayText }}
  </span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  quizMode: {
    type: String,
    required: true,
    validator: (value) => ["BOTH_REQUIRED", "SKIP_INSPECTION", "SKIP_QUIZ"].includes(value),
  },
  stepsToInspectCount: {
    type: Number,
    required: true,
  },
  hasMicrolearning: {
    type: Boolean,
    required: true,
  },
});

const displayState = computed(() => {
  if (!props.hasMicrolearning) return "inspector-only";
  if (props.quizMode === "SKIP_INSPECTION") return "skipped";
  return "steps";
});

const displayText = computed(() => {
  if (displayState.value === "inspector-only") return "—";
  if (displayState.value === "skipped") return "Skipped";

  const stepLabel = props.stepsToInspectCount === 1 ? "Step" : "Steps";
  return `${props.stepsToInspectCount} ${stepLabel}`;
});
</script>

<style scoped>
.checkpoint-inspection-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
  pointer-events: none;
  cursor: default;
  user-select: none;
}

.checkpoint-inspection-badge--steps,
.checkpoint-inspection-badge--skipped {
  padding: var(--spacing-xxs, 2px) var(--spacing-md, 8px);
  border: 1px solid;
  border-radius: 9999px;
}

.checkpoint-inspection-badge--steps {
  color: var(--component-colors-utility-brand-utility-brand-700, #6941c6);
  background: var(--component-colors-utility-brand-utility-brand-50, #f9f5ff);
  border-color: var(--component-colors-utility-brand-utility-brand-200, #e9d7fe);
}

.checkpoint-inspection-badge--skipped {
  color: var(--component-colors-utility-gray-utility-gray-700, #344054);
  background: var(--component-colors-utility-gray-utility-gray-50, #f9fafb);
  border-color: var(--component-colors-utility-gray-utility-gray-200, #eaecf0);
}

.checkpoint-inspection-badge--inspector-only {
  color: var(--component-colors-utility-gray-utility-gray-700, #344054);
}
</style>
